import { render, staticRenderFns } from "./ProfileReport.vue?vue&type=template&id=f974a0dc"
import script from "./ProfileReport.js?vue&type=script&lang=js&external"
export * from "./ProfileReport.js?vue&type=script&lang=js&external"
import style0 from "./ProfileReport.vue?vue&type=style&index=0&id=f974a0dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports